export enum FilterPopoverTabs {
  Whitelabels,
  Clients,
}
